import ApiClient from '@/api/ApiClient';
import Language from '@/api/models/Language';
import Collection from '@/helpers/Collection';

class LanguageService {
    #prefixUrl = 'api/language/';

    constructor() {
        this.api = new ApiClient(this.#prefixUrl);
    }

    /**
     * Gets languages
     * @return {Response}
     */
    getLanguages(key = 'id') {
        
        const languagesList = [
            new Language({
                id: 1,
                name: 'english',
                code: 'en',
                en: 'english',
                pt: 'inglês',
                es: 'Inglés'
            }),
            new Language({
                id: 2,
                name: 'portuguese',
                code: 'pt',
                en: 'portuguese',
                pt: 'português',
                es: 'portugués'
            }),
            new Language({
                id: 3,
                name: 'spanish',
                code: 'es',
                en: 'spanish',
                pt: 'espanhol',
                es: 'español'
            }),
        ]

        let list = [];
        for (let item of languagesList) {
            list.push(new Language(item));
        }

        return new Collection(list, key);
    }

    getLanguage(langId = null) {
        const languages = this.getLanguages();
        return languages.get(langId) || null;
    }
}

export default new LanguageService();
